import { LocalizationProvider as LocalizationProviderMui} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";

const LocalizationProviderCustom = (props) => {
  return (
    <LocalizationProviderMui dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      {props.children}
    </LocalizationProviderMui>
  );
};

export default LocalizationProviderCustom;
